const ANIMATION_DURATION = 0.8;
let heightFirstProject =
  document.querySelector(".first-project").clientHeight + 70;
let windowHeight = window.innerHeight;
let heightFooter = document.querySelector("footer").clientHeight;
let marginFirstProject = windowHeight - heightFirstProject;

// gsap.registerPlugin(CustomEase, ScrollTrigger);
// CustomEase.create(
//     "hop",
//     "M0,0 C0.439,-0.034 0.448,0.287 0.488,0.5 0.525,0.702 0.526,1.048 1,1"
// );
// const animation = gsap
//     .timeline()
//     .to(".is-first.title-second",{ duration: ANIMATION_DURATION, right: 0, ease: "hop" },"title")
//     .fromTo(
//         ".project.first-project",
//         { marginTop: windowHeight * 0.8 },
//         { duration: ANIMATION_DURATION, marginTop: marginFirstProject, ease: "hop" },
//         "title"
//     )
//     .to(".tags", { duration: ANIMATION_DURATION, opacity: 0, ease: "hop" }, "title")
//     .to(".our-work__text",
//         {
//             duration: ANIMATION_DURATION,
//             y: "-100%",
//             opacity: 0,
//             ease: "hop",
//             onComplete: () => isProccesScroll = false,
//         },
//         "title"
//     )
//     .pause();

// /* -----------------------------------------Scroll------------------------------------------ */
// let scrollTimer = false;
// let aaa = false;
// let isProccesScroll = true;
// let isFirstScroll = true;
// let isAnimate = true;
// const projects = gsap.utils.toArray(".project__wrapper");
// let y = "0vhpx";
// let count = 0;

//     window.addEventListener("wheel",function (e) {
//         let date = Date.now();
//         let t = new Date(date);
//         console.log(t.toISOString());
//         window.clearInterval(scrollTimer);
//         scrollTimer = this.window.setTimeout(() => aaa = false, 100)
//         if(aaa) return

//         if(e.deltaY == 0) return
//         console.log('scroll');
//         console.log(e.deltaY);
//         console.log(count);
//         let isUp = e.deltaY < 0;
//         let isDown = e.deltaY > 0;

//         if (isFirstScroll && isDown) {
//             aaa = true
//             console.log("FIRST DOWN");
//             isFirstScroll = false;
//             projectScaleAnimation(projects, count);

//             return animation.play();
//         }

//         if (!isFirstScroll && isUp && count == 0 && !isProccesScroll) {
//             aaa = true
//             console.log(" ! FIRST UP");
//             isProccesScroll = true;
//             projectScaleAnimation(projects, count, true);

//             return animation.reverse().then(() => (isFirstScroll = true));
//         }

//         if (!isProccesScroll) {
//             aaa = true
//             console.log("! PROCESS");

//             if (isUp && count == 0) return;
//             if (isDown && count == projects.length) return;

//             if (isDown && count == projects.length - 1) {
//                 console.log("! PROCESS DOWN");
//                 isProccesScroll = true;
//                 count = count + 1;
//                 document.querySelector("footer").style.bottom = 0;
//                 calculateDownTranslateY();

//                 return projectsMoveAnimation();
//             }

//             if (isUp && count == projects.length) {
//                 console.log("! PROCESS UP");
//                 isProccesScroll = true;
//                 document.querySelector("footer").style.bottom = "-100%";
//                 calculateUpTranslateY();
//                 count = count - 1;

//                 return projectsMoveAnimation();
//             }

//             isProccesScroll = true;
//             let yy = 0;

//             if (isDown) {
//                 console.log("DOWN");
//                 calculateDownTranslateY();
//                 // this.document.querySelector('.project').classList.toggle('opacity-2')
//                 this.document.querySelectorAll('.project__wrapper')[count].classList.toggle('opacity-2')
//                 count = count + 1;
//                 projectScaleAnimation(projects, count);
//                 projectsMoveAnimation();
//             }
//             if (isUp) {
//                 console.log("UP");
//                 calculateUpTranslateY();
//                 count = count - 1;
//                 this.document.querySelectorAll('.project__wrapper')[count].classList.toggle('opacity-2')
//                 projectScaleAnimation(projects, count + 1, true);
//                 projectsMoveAnimation();
//             }
//         }
//     });

// function checkDirection(scrollY) {
//     let direction = scrollY > 1 ? 1 : -1;

//     return direction;
// }

// function projectScaleAnimation(procects, i, back = false) {
//     let project = procects[i]?.querySelector(".project");

//     if (project) {
//         if (back) {
//             gsap.to(project, {
//                 duration: ANIMATION_DURATION,
//                 scale: 0.7,
//                 ease: "hop",
//             });
//         } else {
//             gsap.to(project, {
//                 duration: ANIMATION_DURATION,
//                 scale: 1,
//                 ease: "hop",
//             });
//         }
//     }
// }

// function projectsMoveAnimation() {
//     gsap.to(".project__wrapper", {
//         duration: ANIMATION_DURATION,
//         y: y,
//         ease: "hop",
//         onComplete: () => isProccesScroll = false

//     });
// }

// function calculateDownTranslateY() {
//     let moveToProject = projects[count + 2];

//     if (moveToProject) {
//         let x = moveToProject.getBoundingClientRect().top - windowHeight + 20;
//         y = parseInt(y) - x + "px";
//     }

//     if(! moveToProject && count != projects.length) {
//         let x = projects[count + 1].clientHeight + 50;
//         y = parseInt(y) - x + "px";
//     }

//     if (count == projects.length) {
//         y = parseInt(y) - heightFooter + 100 + 'px';
//     }
// }

// function calculateUpTranslateY() {
//     let moveToProject = projects[count];
//     if (moveToProject && count != projects.length) {
//         let x = windowHeight - moveToProject.getBoundingClientRect().top - 20;
//         y = parseInt(y) + x + "px";
//     }

//     if (count == projects.length) {

//         y = parseInt(y) + heightFooter -100  + 'px';
//     }
// }

gsap.registerPlugin(ScrollTrigger, CustomEase, ScrollToPlugin);
const portfolioWrap = document.querySelector(".our-work");
const projects = document.querySelectorAll(".project__anim");
const mm = gsap.matchMedia();

document.querySelector('.all-project-wrap').style.opacity = "1";

mm.add("(min-width:640px)", () => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: portfolioWrap,
      start: "top top",
      end: "1000",
      pin: true,
      scrub: 1,
    },
  });

  tl.to(
    ".is-first.title-second",
    {
      duration: ANIMATION_DURATION,
      right: 0,
      ease: "hop",
    },
    "title"
  )
    .from(
      ".all-project-wrap",
      {
        y: "60vh",
        duration: ANIMATION_DURATION,
        ease: "hop",
      },
      "title"
    )
    .to(
      ".first__wrap",
      {
        scale: 1,
        duration: ANIMATION_DURATION,
        ease: "hop",
      },
      "title"
    )
    .to(
      ".tags",
      {
        duration: ANIMATION_DURATION,
        opacity: 0,
        ease: "hop",
      },
      "title"
    )
    .to(
      ".our-work__text",
      {
        duration: ANIMATION_DURATION,
        yPercent: -100,
        opacity: 0,
        ease: "hop",
      },
      "title"
    );
  
  projects.forEach((project) => {
    gsap.to(project, {
      scrollTrigger: {
        trigger: project,
        start: "top top+=70%",
        scrub: true,
      },
      scale: 1,
    });
  });
});


// window.addEventListener("resize", function(){
//   if (window.innerWidth > 640) {
//     animateProject();
//   }else {
//     tl.pause(0).kill(true);
//     ScrollTrigger.getById('.our-work').kill(true);
//   }
// });